export const timeUnitStatuses = {
  all: 'All',
  draft: 'Draft',
  submitted: 'Submitted',
  approved: 'Approved',
  declined: 'Declined',
};

export default Object.values(timeUnitStatuses);
